/**
 * Inline SVG path data for icons not available in @inmar/hc-ui-icons (fal variant).
 *
 * `circle-exclamation` and `clone` only exist in the `fas` (solid) prefix or
 * not at all. These constants allow rendering them as inline SVGs in light style
 * matching the rest of the icon set.
 */

export const EXCLAMATION_CIRCLE_PATH =
  'M9.6 19.2C4.2975 19.2 0 14.9025 0 9.6C0 4.2975 4.2975 0 9.6 0C14.9025 0 19.2 4.2975 19.2 9.6C19.2 14.9025 14.9025 19.2 9.6 19.2ZM9.6 1.2C4.96125 1.2 1.2 4.96125 1.2 9.6C1.2 14.2388 4.96125 18 9.6 18C14.2388 18 18 14.2388 18 9.6C18 4.96125 14.2388 1.2 9.6 1.2ZM9.6 14.4C9.10125 14.4 8.7 13.9988 8.7 13.5C8.7 13.0013 9.10125 12.6 9.6 12.6C10.0988 12.6 10.5 13.0013 10.5 13.5C10.5 13.9988 10.0988 14.4 9.6 14.4ZM9.6 4.8C10.1063 4.8 10.5113 5.2275 10.4813 5.73375L10.1963 10.8338C10.1775 11.1525 9.915 11.4 9.59625 11.4C9.2775 11.4 9.015 11.1525 8.99625 10.8338L8.71125 5.73375C8.68125 5.2275 9.08625 4.8 9.5925 4.8H9.6Z';

export const CLONE_PATH =
  'M10.9367 18.2278H2.43038C1.75823 18.2278 1.21519 17.6848 1.21519 17.0127V8.50633C1.21519 7.83418 1.75823 7.29114 2.43038 7.29114H4.25316V6.07595H2.43038C1.08987 6.07595 0 7.16582 0 8.50633V17.0127C0 18.3532 1.08987 19.443 2.43038 19.443H10.9367C12.2772 19.443 13.3671 18.3532 13.3671 17.0127V15.1899H12.1519V17.0127C12.1519 17.6848 11.6089 18.2278 10.9367 18.2278ZM8.50633 12.1519C7.83418 12.1519 7.29114 11.6089 7.29114 10.9367V2.43038C7.29114 1.75823 7.83418 1.21519 8.50633 1.21519H17.0127C17.6848 1.21519 18.2278 1.75823 18.2278 2.43038V10.9367C18.2278 11.6089 17.6848 12.1519 17.0127 12.1519H8.50633ZM6.07595 10.9367C6.07595 12.2772 7.16582 13.3671 8.50633 13.3671H17.0127C18.3532 13.3671 19.443 12.2772 19.443 10.9367V2.43038C19.443 1.08987 18.3532 0 17.0127 0H8.50633C7.16582 0 6.07595 1.08987 6.07595 2.43038V10.9367Z';

export const SVG_ICONS = {
  'exclamation-circle': {
    path: EXCLAMATION_CIRCLE_PATH,
    viewBox: '0 0 20 20',
  },
  clone: {
    path: CLONE_PATH,
    viewBox: '0 0 20 20',
  },
} as const;

export type InlineSvgIconName = keyof typeof SVG_ICONS;
